window.addEventListener('DOMContentLoaded', () => {
  const messagingCoachingCheckbox = document.querySelector(
    '#messaging-coaching-checkbox'
  );
  const ongoingCareCheckbox = document.querySelector('#ongoing-care-checkbox');
  const product_id_element = document.querySelector(
    'form input[name="product_id"]'
  );
  checkboxOption(
    ongoingCareCheckbox,
    messagingCoachingCheckbox,
    product_id_element
  );
  checkboxOption(
    messagingCoachingCheckbox,
    ongoingCareCheckbox,
    product_id_element
  );

  if (messagingCoachingCheckbox?.checked) {
    product_id_element.value = messagingCoachingCheckbox.value;
  }
  if (ongoingCareCheckbox?.checked) {
    product_id_element.value = ongoingCareCheckbox.value;
  }

  function checkboxOption(main, secondary, product_id_element) {
    if (main && secondary && product_id_element) {
      const product_id = product_id_element.value;
      main.addEventListener('change', () => {
        if (main.checked) {
          secondary.checked = false;
          product_id_element.value = main.value;
        } else {
          if (secondary.checked == false) {
            product_id_element.value = product_id;
          }
        }
      });
    }
  }
});
